import { Asset } from 'app-lib/assetUtils'
import { chainConfigs } from 'bzx-common/src/config/appConfig'
import { LendType } from 'bzx-common/src/domain/lendTypes'
import { LendStore, RootStore } from 'bzx-common/src/stores'
import _ from 'lodash'
import * as mobx from 'mobx'
import { DialogVM } from 'ui-framework'
import LendFormVM from './LendForm/LendFormVM'

interface ILendVMProps {
  assetSelected: Asset | null
  lendForm: LendFormVM
  searchQuery: string
  sortBy: 'supplyApr' | 'liquidity' | 'asset'
  sortOrder: 'asc' | 'desc'
}

export default class LendVM implements ILendVMProps {
  assetSelected: Asset | null = null
  lendDialog = new DialogVM({ id: 'lend-dialog' })
  lendForm: LendFormVM
  lendStore: LendStore
  rootStore: RootStore
  searchQuery = ''
  sortBy: 'supplyApr' | 'liquidity' | 'asset' = 'supplyApr'
  sortOrder: 'asc' | 'desc' = 'desc'
  stopAutoSync: mobx.IReactionDisposer | null = null

  get fetchingData() {
    return this.lendStore.userYields.pending || this.rootStore.statsStore.stats.pending
  }

  /**
   * Ordered and filtered list, per user criteria
   */
  get filteredLendItems() {
    let filtered = this.lendStore.lendItems
    if (this.searchQuery) {
      filtered = filtered.filter((item) =>
        item.asset.toLowerCase().includes(this.searchQuery.toLowerCase())
      )
    }
    return _.orderBy(filtered, [this.sortBy], [this.sortOrder])
  }

  get filteredYieldList() {
    return this.filteredLendItems.filter((item) => !!item.userYield)
  }

  set(prop: keyof ILendVMProps, value: any) {
    ;(this[prop] as any) = value
  }

  sortList(by: 'supplyApr' | 'liquidity' | 'asset') {
    if (this.sortBy === by) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
    } else {
      this.sortBy = by
    }
  }

  showForm(asset: Asset, lendType: LendType) {
    const { chainId } = this.rootStore.web3Connection
    if (!chainId) {
      return
    }
    const chain = chainConfigs[chainId]
    this.assetSelected = asset
    const formAsset =
      !chain.nativeTokenSupported && asset === chain.native.asset ? chain.native.wrapped : asset
    this.lendForm = new LendFormVM(formAsset, lendType, this.rootStore, this.lendDialog)
    this.lendDialog.show()
    this.lendForm.init()
  }

  showLendForm(asset: Asset) {
    this.showForm(asset, LendType.LEND)
  }

  showUnlendForm(asset: Asset) {
    this.showForm(asset, LendType.UNLEND)
  }

  init() {
    setTimeout(() => {
      this.lendStore.autoSync(true)
    }, 0)
  }

  destroyVM() {
    this.lendStore.autoSync(false)
    this.lendForm.destroyVM()
  }

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore
    this.lendStore = rootStore.lendStore
    this.lendForm = new LendFormVM(Asset.ETH, LendType.LEND, this.rootStore, this.lendDialog)
    mobx.makeAutoObservable(this, undefined, { autoBind: true, deep: false })
    this.init()
  }
}
